import { ToastType } from "../components/ui/toast";
import { RateGroup, RateItem } from "../features/actuarial/rates-state";

export interface ValidationError {
    age: string;
    name: string;
    type: "plan" | "rider";
}

export const isInvalidAmountRates = (amount: string | number | null | undefined) => {
    if (amount === null || amount === undefined) return true;
    const normalized =
        typeof amount === "string"
            ? amount.replace(/,/g, "").trim()
            : String(amount);
    // ❌ only reject empty string after trim
    return normalized === "";
};

export const validate1865 = (data: RateGroup[]): ValidationError[] => {
    const errors: ValidationError[] = [];
    data?.forEach((group) => {
        group.data.forEach((item) => {
            if (isInvalidAmountRates(item.amount)) {
                errors.push({
                    age: group.title,
                    name: item.acronym,
                    type: item.type as "plan" | "rider",
                });
            }
        });
    });
    return errors;
};

export const validate66to80Group = ( groups: RateGroup[], label: string, showToastNotify: (message: string, type: ToastType) => void ): boolean => {

    for (const group of groups) {
        if (!group?.data?.length) continue;
        const invalidItem = group.data.find((item: RateItem) =>
            isInvalidAmountRates(item.amount)
        );
        if (invalidItem) {
            showToastNotify(`${label} of "${invalidItem.acronym}" has empty rate`, "error");
            return false;
        }
    }
    return true;
};